import { DEFAULT_GROUP_LABEL } from '../constants';
import type { Option, OptionGroup } from '../types';

export function convertToOptionGroups<O extends Option>(
  options?: OptionGroup<O> | OptionGroup<O>[] | O[],
): OptionGroup<O>[] {
  if (!Array.isArray(options)) {
    return [options as OptionGroup<O>];
  }

  if (options.length === 0) {
    return [];
  }

  if ((options[0] as OptionGroup<O>).options !== undefined) {
    return options as OptionGroup<O>[];
  }

  return [
    {
      label: DEFAULT_GROUP_LABEL,
      options: options as O[],
    },
  ];
}
